import { render } from "./PlanPersonIframe.vue?vue&type=template&id=7c5b4ad2&ts=true"
import script from "./PlanPersonIframe.ts?vue&type=script&lang=ts&external"
export * from "./PlanPersonIframe.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__